import React from 'react'
import { Tabs,Col } from 'antd'
import ChangePasswordTab from './components/changePassword';
import './myProfile.css'
import MyPersonalDetails from './components/personalDetails';

const MyProfile = () => {
    const { TabPane } = Tabs;
    return (
        <div className='myProfile-main-div'>
            <Col className='myProfile-body' xs={24} lg={15} md={15} sm={24}>
                <div className='myProfile-heading'>
                    My profile
                </div>
                <div style={{ backgroundColor: '#fff' }}>
                    <Tabs 
                    
                    defaultActiveKey="1" 
                    tabBarGutter={75}  
                    tabBarStyle={{
                        paddingLeft:'3%',
                        color: '#7e7e7e',
                    }}
                    >
                        <TabPane 
                        tab="Personal details" 
                        key="1" 
                        >
                            <MyPersonalDetails />
                        </TabPane>
                        <TabPane tab="Change password" key="2">
                            <ChangePasswordTab />
                        </TabPane>
                    </Tabs>
                </div>
            </Col>
        </div>
    )
}

export default MyProfile;